import React from "react";
import classes from "./ListTypeB.module.scss";
import { IBlock } from "../list-type-a/ListTypeA";

const ListTypeB: React.FC<{ title: string; blocks: IBlock[] }> = ({
  title,
  blocks,
}) => {
  return (
    <div className={classes.container}>
      <h2 className={classes.title}>{title}</h2>

      <div className={classes["blocks-list"]}>
        {blocks.map((block, i) => (
          <div key={i} className={classes.block}>
            <span className={classes.emoji}>{block.iconSvg}</span>
            <span className={classes.text}>{block.text}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ListTypeB;
